import { __assign, __rest } from "tslib";
import cx from 'classnames';
import React, { Children, cloneElement, useCallback, useEffect, } from 'react';
import { CloseButton } from '@mercell/close-button-react';
import { InformationFilled32, CheckmarkFilled32, WarningFilled32, Misuse32, } from '@carbon/icons-react';
import { twMerge } from 'tailwind-merge';
import { colorSchemes } from '@mercell/tailwind';
export var Alert = function (_a) {
    var scheme = _a.scheme, className = _a.className, children = _a.children, timeout = _a.timeout, iconProps = _a.iconProps, closeAlertCallback = _a.closeAlertCallback, rest = __rest(_a, ["scheme", "className", "children", "timeout", "iconProps", "closeAlertCallback"]);
    var renderIcon = useCallback(function () {
        var extendedIconProps = __assign(__assign({}, iconProps), { className: cx('max-w-[22px] max-h-[22px] mt-1', '[&>path[data-icon-path="inner-path"]]:fill-white [&>path[data-icon-path="inner-path"]]:opacity-100', {
                'fill-matisse': scheme === 'information',
                'fill-tropical-rain-forest': scheme === 'success',
                'fill-well-read': scheme === 'error',
                'fill-california': scheme === 'important',
            }) });
        var icon;
        switch (scheme) {
            case 'success':
                icon = (React.createElement(CheckmarkFilled32, __assign({ path: "white" }, extendedIconProps)));
                break;
            case 'information':
                icon = React.createElement(InformationFilled32, __assign({}, extendedIconProps));
                break;
            case 'error':
                icon = React.createElement(Misuse32, __assign({}, extendedIconProps));
                break;
            case 'important':
                icon = React.createElement(WarningFilled32, __assign({}, extendedIconProps));
                break;
            default:
                icon = null;
                break;
        }
        return React.createElement("div", { className: "max-w-[22px]" }, icon);
    }, [iconProps, scheme]);
    useEffect(function () {
        var timeoutId;
        if (timeout && closeAlertCallback) {
            timeoutId = setTimeout(function () { return closeAlertCallback(); }, timeout);
        }
        return function () {
            clearTimeout(timeoutId);
        };
    }, [timeout, closeAlertCallback]);
    return (React.createElement("div", __assign({}, rest, { className: twMerge('flex p-4 w-full rounded-default text-left relative', colorSchemes(scheme), className) }),
        renderIcon(),
        closeAlertCallback && (React.createElement("div", { className: "absolute top-2 right-2" },
            React.createElement(CloseButton, { onClick: closeAlertCallback, className: "p-0" }))),
        React.createElement("div", { className: "ml-8 w-[calc(100%-22px)]" }, Children.toArray(children).map(function (child) {
            var _a;
            return cloneElement(child, __assign({ className: cx((_a = child.props.className) !== null && _a !== void 0 ? _a : '') }, child.props));
        }))));
};
